import Icon, { IconProps } from './Icon';

import SendIcon from '../../../assets/icons/send.svg?react';

const Send: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <SendIcon />
    </Icon>
  );
};

export default Send;
